import axios from "axios";
import { BACKEND_BASE_URL } from "./baseurl";
import { getAuthToken } from "utils/authToken";

const BACKEND_URL = BACKEND_BASE_URL;

const axiosInstance = axios.create({
  baseURL: BACKEND_URL,
});

// ── PUBLIC routes that must NOT attach an Authorization header ──────────────
const PUBLIC_URL_PREFIXES = [
  "admin/admin-sign-in",
  "app/v1/auth/send-otp",
  "app/v1/auth/verify-otp",
  "app/v1/auth/get-freelancer-data",
  "client/v1/auth/new-google-sign-in",
];

const isPublicUrl = (url = "") =>
  PUBLIC_URL_PREFIXES.some((prefix) => url.includes(prefix));

// Add a request interceptor
axiosInstance.interceptors.request.use(
  async function (config) {
    if (isPublicUrl(config.url)) {
      // Public/auth endpoints — attach no Authorization header
      config.headers = {
        ...config.headers,
        Accept: "application/json",
        "Content-Type": config.headers["Content-Type"] || "application/json",
      };
      return config;
    }

    // Protected endpoints — URL token first, then localStorage
    const token = getAuthToken();

    console.log("auth token", token);

    config.headers = {
      ...config.headers,
      Authorization: token ? `${token}` : "",
      Accept: "application/json",
      "Content-Type": config.headers["Content-Type"] || "multipart/form-data;",
    };

    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

let isRedirectingToSignIn = false;

// Add a response interceptor
axiosInstance.interceptors.response.use(
  async function (response) {
    const result = response?.data;
    return result;
  },
  function (error) {
    if (error?.response?.status === 401) {
      const token = getAuthToken();
      if (token && !isRedirectingToSignIn) {
        isRedirectingToSignIn = true;
        try {
          localStorage.removeItem("adminToken");
          localStorage.removeItem("session");
        } catch (e) {}
        setTimeout(() => {
          window.location.href = "/client/sign-in";
        }, 500);
      }
    }
    if (error?.response?.data) {
      error.response.data = error.response.data;
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
